
import { createSlice } from '@reduxjs/toolkit';

// Leave Slice
const leaveSlice = createSlice({
  name: 'leave',
  initialState: {
    leaveRequestData: null,
  },
  reducers: {
    setLeaveRequestData: (state, action) => {
      state.leaveRequestData = action.payload;
    },
    clearLeaveRequestData: (state) => {
      state.leaveRequestData = null;
    },
  },
});

// Feed Slice
const feedSlice = createSlice({
  name: 'feedData',
  initialState: {
    feedRequestData: null,
  },
  reducers: {
    setFeedRequestData: (state, action) => {
      state.feedRequestData = action.payload;
    },
    clearFeedRequestData: (state) => {
      state.feedRequestData = null;
    },
  },
});

// sidebar Create Post
const sidebarPostSlice = createSlice({
  name: 'createPostData',
  initialState: {
    postRequestData: null,
  },
  reducers: {
    setCreatePostRequestData: (state, action) => {
      state.postRequestData = action.payload;
    },
    clearCreatePostRequestData: (state) => {
      state.postRequestData = null;
    },
  },
});

//Search Result
const searchReasult = createSlice({
  name: 'searchResult',
  initialState: {
    searchRequestData: null,
  },
  reducers: {
    setSearchRequestData: (state, action) => {
      state.searchRequestData = action.payload;
    },
    clearSearchRequestData: (state) => {
      state.searchRequestData = null;
    },
  },
});

//Search Result
const messageResultData = createSlice({
  name: 'messageResult',
  initialState: {
    messageRequestData: null,
  },
  reducers: {
    setMessageRequestData: (state, action) => {
      state.messageRequestData = action.payload;
    },
    clearMessageRequestData: (state) => {
      state.messageRequestData = null;
    },
  },
});

//Search Nofification
const manageMotificationCount = createSlice({
  name: 'notificationCounts',
  initialState: {
    notificationRequestData: null,
  },
  reducers: {
    setNotificationRequestData: (state, action) => {
      state.notificationRequestData = action.payload;
    },
    clearNotificationRequestData: (state) => {
      state.notificationRequestData = null;
    },
  },
});

//Search Nofification
const manageRecentProjects = createSlice({
  name: 'recentProjects',
  initialState: {
    recentProjectData: null,
  },
  reducers: {
    setRecentProjectData: (state, action) => {
      state.recentProjectData = action.payload;
    },
    clearRecentProjectData: (state) => {
      state.recentProjectData = null;
    },
  },
});

// Export reducers
export const leaveReducer = leaveSlice.reducer;
export const feedReducer = feedSlice.reducer;
export const sidebarPostReducer = sidebarPostSlice.reducer;
export const searchReasultReducer = searchReasult.reducer;
export const showMessageMember = messageResultData.reducer;
export const showRecentProjects = manageRecentProjects.reducer;
export const showNotificationCount = manageMotificationCount.reducer;



// Export actions
export const { setLeaveRequestData, clearLeaveRequestData } = leaveSlice.actions;
export const { setFeedRequestData, clearFeedRequestData } = feedSlice.actions;
export const {setCreatePostRequestData,clearCreatePostRequestData} = sidebarPostSlice.actions;
export const { setSearchRequestData, clearSearchRequestData } = searchReasult.actions;
export const { setMessageRequestData, clearMessageRequestData } = messageResultData.actions;
export const { setNotificationRequestData, clearNotificationRequestData } = manageMotificationCount.actions;
export const { setRecentProjectData, clearRecentProjectData } = manageRecentProjects.actions;
